import React from "react";
import PickAndPackProvider from "./PickAndPackProvider";
import ViewBnOrders from "./ViewBnOrders";

const ScreenReviewAndAuthorizeSellOrders = () => {
    return <PickAndPackProvider>
        <ViewBnOrders lockedSide="Sell" deliveryStatusFixed="Pending" userAction="ReviewAndAuthorizeSellOrders" />
    </PickAndPackProvider>
}

export default ScreenReviewAndAuthorizeSellOrders;